export default "__VITE_ASSET__iKh7In0A__"